// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"4ad59387","287":"335f35d3","356":"6fcf68a0","491":"3bb0e995","510":"ac5d722e","584":"5c1c5d8e","700":"571b5b7a","761":"c65f7cf1","783":"4a747f63"}[chunkId] + ".chunk.js";
};